import React, { useEffect, useState, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Badge,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
  Button,
  Collapse
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from 'axios';
import toastr from 'toastr';
import classnames from "classnames";
import moment from 'moment'; // Tarih formatlama için

// CSS ve Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import "toastr/build/toastr.min.css";

// FIREBASE IMPORTS
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

const ListingsList = () => {
  document.title = "İlan & Talep Yönetimi | Subsea Admin";

  // --- API Yapılandırması ---
  const API_URL = "https://subseaapi.stechomeyazilim.info/Listings";
  const CATEGORY_API_URL = "https://subseaapi.stechomeyazilim.info/Categories"; 
  const FILE_BASE_URL = "https://subseaapi.stechomeyazilim.info/files/";

  // --- Sabit Seçenekler (İsteklere Göre) ---
  const SERVICE_TYPES = [
    "Electrical", "Electronic", "Hydraulic", "Optical", "Mechanical", 
    "Consulting", "Field Services", "Workshop Services"
  ];
  const EQUIPMENT_TYPES = [
    "Electrical", "Electronic", "Hydraulic", "Optical", "Mechanical"
  ];
  const URGENCY_LEVELS = ["Low", "Normal", "High", "Critical"];
  const BUDGET_RANGES = ["0-1k", "1k-10k", "10k-50k", "50k-100k", "100k+"];

  // --- State Tanımları ---
  const [listings, setListings] = useState([]);
  const [filteredListings, setFilteredListings] = useState([]); // Filtrelenmiş liste
  const [categoriesList, setCategoriesList] = useState([]);
  const [listingEdit, setListingEdit] = useState(null);
  
  // Filtre State'leri
  const [filters, setFilters] = useState({
    category: "",
    type: "", // Service Request / Equipment Request
    urgency: "",
    status: "", // pending / active
    hasDocuments: ""
  });
  const [showFilters, setShowFilters] = useState(true);

  // Resim State'leri
  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploading, setUploading] = useState(false);

  // Modallar
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [listingToDelete, setListingToDelete] = useState(null);
  const [activeTab, setActiveTab] = useState("1"); 

  // --- Helper: Resim URL ---
  const getImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("http")) return url;
    return FILE_BASE_URL + url;
  };

  // --- STATE TANIMLARI ---
const [usersList, setUsersList] = useState([]); // Kullanıcı listesi için

// --- KULLANICILARI ÇEKEN FONKSİYON ---
const fetchUsers = async () => {
  try {
    // API'den tüm kullanıcıları çekiyoruz
    const response = await axios.get("https://subseaapi.stechomeyazilim.info/Users");
    const data = Array.isArray(response.data.value) ? response.data.value : response.data;
    setUsersList(data);
  } catch (error) {
    console.error("Kullanıcılar yüklenemedi:", error);
    toastr.error("Kullanıcı listesi alınamadı.");
  }
};

// useEffect içine fetchUsers'ı ekle (Mevcut useEffect'in içine)
useEffect(() => {
    fetchListings();
    fetchCategories();
    fetchUsers(); // <-- BUNU EKLE
}, []);

  // Filtreleme Mantığı
  useEffect(() => {
    let result = listings;

    if (filters.category) {
      result = result.filter(l => l.CategoryID === parseInt(filters.category));
    }
    if (filters.type) {
      // Backend'deki Type ile eşleşmeli. (request_service / request_equipment gibi varsayıyoruz)
      result = result.filter(l => l.Type === filters.type);
    }
    if (filters.urgency) {
      result = result.filter(l => l.Urgency === filters.urgency);
    }
    if (filters.status) {
      result = result.filter(l => l.Status === filters.status);
    }
    if (filters.hasDocuments) {
      const boolVal = filters.hasDocuments === "true";
      result = result.filter(l => l.HasDocuments === boolVal);
    }

    setFilteredListings(result);
  }, [filters, listings]);

  const fetchListings = async () => {
    try {
      const response = await axios.get(`${API_URL}?$expand=ListingImages,Categories`);
      const data = Array.isArray(response.data.value) ? response.data.value : response.data;
      setListings(data);
      setFilteredListings(data); // İlk başta hepsi
    } catch (error) {
      console.error("Listings error:", error);
      toastr.error("İlanlar yüklenirken hata oluştu.");
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(CATEGORY_API_URL);
      const data = Array.isArray(response.data.value) ? response.data.value : response.data;
      setCategoriesList(data);
    } catch (error) {
      console.error("Categories fetch error:", error);
    }
  }

  // --- İlan Onaylama (Approve) ---
  const handleApprove = async (listing) => {
    try {
      // Status'u Active yapıyoruz
      await axios.put(`${API_URL}(${listing.ID})`, { ...listing, Status: 'active' });
      toastr.success(`İlan ID: ${listing.ID} onaylandı ve yayına alındı.`);
      fetchListings();
    } catch (error) {
      console.error("Approve error", error);
      toastr.error("Onaylama işlemi başarısız.");
    }
  };

  // --- Firebase Upload ---
  const handleImageUpload = async (file) => {
    if (!file) return;
    try {
      setUploading(true);
      const storage = getStorage();
      const fileName = `listings/${Date.now()}_${file.name}`;
      const storageRef = ref(storage, fileName);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on("state_changed", () => {}, (err) => {
          setUploading(false);
          toastr.error("Upload hatası");
      }, () => {
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setUploadedImage(url);
            setUploading(false);
            toastr.success("Görsel yüklendi.");
          });
      });
    } catch (error) {
      setUploading(false);
    }
  };

  // --- Formik ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      // Ortak Alanlar
      Title: listingEdit?.Title || "",
      Type: listingEdit?.Type || "request_equipment", // Default: Equipment Request
      Status: listingEdit?.Status || "pending",
      CategoryID: listingEdit?.CategoryID || "",
      Description: listingEdit?.Description || "",
      Urgency: listingEdit?.Urgency || "Normal",
      BudgetRange: listingEdit?.BudgetRange || "",
      RequiredDeliveryDate: listingEdit?.RequiredDeliveryDate ? listingEdit.RequiredDeliveryDate.split('T')[0] : "",
      ListingExpirationDate: listingEdit?.ListingExpirationDate ? listingEdit.ListingExpirationDate.split('T')[0] : "",
      LocationCountry: listingEdit?.LocationCountry || "",
      LocationCity: listingEdit?.LocationCity || "",
      HasDocuments: listingEdit?.HasDocuments || false,
      ContactHidden: listingEdit?.ContactHidden || false,
      IsActive: listingEdit?.IsActive ?? true,
      CompanyID: listingEdit?.CompanyID || "",
      UserID: listingEdit?.UserID || "",

      // Service Request Özel
      ServiceType: listingEdit?.SpecificationsJson ? JSON.parse(listingEdit.SpecificationsJson).ServiceType : "",
      
      // Equipment Request Özel
      Manufacturer: listingEdit?.SpecificationsJson ? JSON.parse(listingEdit.SpecificationsJson).Manufacturer : "",
      SaleType: listingEdit?.SaleType || "sale",
      Condition: listingEdit?.Condition || "used", // New/Used
      EquipmentType: listingEdit?.SpecificationsJson ? JSON.parse(listingEdit.SpecificationsJson).EquipmentType : "",
      
      PriceValue: listingEdit?.PriceValue || "",
      PriceCurrency: listingEdit?.PriceCurrency || "USD",
    },
    validationSchema: Yup.object({
      Title: Yup.string().required("Başlık zorunludur"),
      CategoryID: Yup.number().required("Kategori seçimi zorunludur"),
      UserID: Yup.number().required("İlan sahibi (Kullanıcı) seçilmelidir"), // Zorunlu yaptık
      Type: Yup.string().required("Talep tipi seçilmelidir"),
    }),

    onSubmit: async (values) => {
    // 1. KULLANICI VE TİP HAZIRLIĞI
    const storedUser = localStorage.getItem("user");
    const currentUser = storedUser ? JSON.parse(storedUser) : null;
    
    // ŞEMAYA GÖRE: Listings tablosundaki UserID 'int NULL'dur.
    // Eğer currentUser yoksa, rastgele 1 veya 19 göndermek yerine NULL gönderiyoruz.
    // Böylece "Foreign Key Constraint" hatası almazsın.
    const activeUserId = currentUser?.ID ? parseInt(currentUser.ID) : null;
    const activeCompanyId = currentUser?.CompanyID ? parseInt(currentUser.CompanyID) : null;

    // Tip Düzeltmesi (Admin panelindeki value -> DB'deki value)
    let cleanType = values.Type;
    if (values.Type === 'request_equipment') cleanType = 'equipment';
    if (values.Type === 'request_service') cleanType = 'service';

    // 2. PAYLOAD (TABLO YAPISINA TAM UYUMLU)
    const mainPayload = {
        // --- ZORUNLU ALANLAR (NOT NULL) ---
        Title: values.Title,
        Type: cleanType, // nvarchar(32)
        
        // Şemada Default 'pending' var ama biz garanti olsun diye gönderiyoruz
        Status: values.Status || "active", 
        
        // Şemada Default 'na' var. Equipment ise seçileni, değilse 'na' gönderiyoruz.
        Condition: (cleanType === 'equipment' && values.Condition) ? values.Condition : "na", 
        SaleType: (cleanType === 'equipment' && values.SaleType) ? values.SaleType : "na",

        // --- NULL OLABİLEN İLİŞKİSEL ALANLAR (FK) ---
        // Rastgele sayı göndermektense, değer yoksa NULL gönderiyoruz.
        UserID: parseInt(values.UserID),
        CompanyID: values.CompanyID ? parseInt(values.CompanyID) : activeCompanyId,
        CategoryID: values.CategoryID ? parseInt(values.CategoryID) : null,

        // --- DİĞER NULLABLE ALANLAR ---
        Description: values.Description || null,
        Urgency: values.Urgency || null,
        BudgetRange: values.BudgetRange || null,
        
        // Sayısal Değerler (Decimal)
        PriceValue: values.PriceValue ? parseFloat(values.PriceValue.toString().replace(',', '.')) : null,
        PriceCurrency: values.PriceCurrency || "USD",
        
        // Tarih Değerleri (datetime2)
        // Eğer tarih seçilmediyse null gönderiyoruz (SQL kabul eder)
        RequiredDeliveryDate: values.RequiredDeliveryDate ? new Date(values.RequiredDeliveryDate).toISOString() : null,
        ListingExpirationDate: values.ListingExpirationDate ? new Date(values.ListingExpirationDate).toISOString() : null,
        
        // Lokasyon
        LocationCountry: values.LocationCountry || null,
        LocationCity: values.LocationCity || null,

        // --- BOOLEAN ALANLAR (bit) ---
        // Şemada bunlar NOT NULL, kesinlikle true/false gitmeli
        HasDocuments: values.HasDocuments ? true : false,
        ContactHidden: values.ContactHidden ? true : false,
        IsSold: false, // Default 0
        IsActive: true // Default 1 (Nullable ama true gönderelim)
    };

    console.log("SQL Uyumlu Payload:", mainPayload);

    try {
        let response;
        
        // --- 3. İŞLEM ---
        if (isEdit && listingEdit) {
            response = await axios.put(`${API_URL}(${listingEdit.ID})`, mainPayload);
            toastr.success(`İlan (ID: ${listingEdit.ID}) güncellendi.`);
        } else {
            response = await axios.post(API_URL, mainPayload);
            // Backend ID'yi nasıl dönüyor kontrol et (ID veya id)
            const newListingID = response.data.ID || response.data.id;

            if (newListingID) {
                // --- 4. DETAY TABLOLARI (EquipmentDetails / ServiceDetails) ---
                
                if (cleanType === 'equipment') {
                    // dbo.EquipmentDetails tablosuna uygun payload
                    const equipPayload = {
                        ListingID: newListingID,
                        // Eğer ManufacturerID yoksa null gönder (Şemada NULLABLE)
                        ManufacturerID: null, 
                        // String olarak marka adı
                        Manufacturer: values.Manufacturer || null, 
                        Model: values.Model || null,
                        ManufactureYear: values.ManufactureYear ? parseInt(values.ManufactureYear) : null,
                        SerialNo: null,
                        EquipmentType: values.EquipmentType || null,
                        EquipmentCondition: values.Condition || null
                    };
                    await axios.post("https://subseaapi.stechomeyazilim.info/EquipmentDetails", equipPayload);
                } 
                else if (cleanType === 'service') {
                    // dbo.ServiceDetails tablosuna uygun payload
                    const servicePayload = {
                        ListingID: newListingID,
                        ServiceTypeID: null, // FK, nullable
                        ServiceType: values.ServiceType || null,
                        RateCurrency: values.PriceCurrency || "USD",
                        RateValue: values.PriceValue ? parseFloat(values.PriceValue.toString().replace(',', '.')) : null,
                        RateUnit: "day" // Varsayılan
                    };
                    await axios.post("https://subseaapi.stechomeyazilim.info/ServiceDetails", servicePayload);
                }

                // --- 5. RESİM YÜKLEME (dbo.ListingImages) ---
                if (uploadedImage) {
                    await axios.post("https://subseaapi.stechomeyazilim.info/ListingImages", {
                        ListingID: newListingID,
                        Url: uploadedImage,
                        IsCover: true,
                        SortOrder: 0
                    });
                }
                
                toastr.success("İlan başarıyla veritabanına işlendi.");
            }
        }

        setModal(false);
        fetchListings();
        setUploadedImage(null);

    } catch (error) {
        console.error("SQL/API Hatası:", error);
        
        // Hata mesajını ayrıştır
        let errorMsg = "Sunucu Hatası (500)";
        if (error.response && error.response.data) {
            // İç içe hata mesajlarını kontrol et
            errorMsg = error.response.data.Message 
                    || error.response.data.ExceptionMessage 
                    || (error.response.data.innererror ? error.response.data.innererror.message : error.message);
        }
        
        toastr.error(`Kayıt Başarısız: ${errorMsg}`);
    }
}

  });

  // --- Tablo Kolonları ---
  const columns = useMemo(() => [
      {
        Header: "ID",
        accessor: "ID",
        width: 50,
      },
      {
        Header: "Tarih",
        accessor: "CreatedAt",
        Cell: (cellProps) => moment(cellProps.value).format("DD/MM/YYYY")
      },
      {
        Header: "Görsel",
        accessor: "ListingImages", 
        disableFilters: true,
        Cell: (cellProps) => {
            const images = cellProps.value;
            const cover = images && images.length > 0 ? (images.find(x => x.IsCover) || images[0]) : null;
            return (
                <div className="avatar-sm">
                    {cover ? (
                        <img src={getImageUrl(cover.Url)} alt="Img" className="img-thumbnail rounded h-100 object-cover" />
                    ) : ( <span className="avatar-title rounded bg-soft-secondary text-secondary font-size-10">YOK</span> )}
                </div>
            );
        },
      },
      {
        Header: "Başlık",
        accessor: "Title",
        filterable: true,
        Cell: (cellProps) => (
          <div>
            <h5 className="font-size-14 mb-1 text-truncate" style={{maxWidth: '180px'}}>{cellProps.value}</h5>
            <small className="text-muted">{cellProps.row.original.CompanyID ? `Firma ID: ${cellProps.row.original.CompanyID}` : 'Bireysel'}</small>
          </div>
        )
      },
      {
        Header: "Tip",
        accessor: "Type",
        Cell: (cellProps) => {
           let badgeColor = "primary";
           let text = "Diğer";
           if(cellProps.value === 'request_service') { badgeColor = "info"; text = "Service Req."; }
           if(cellProps.value === 'request_equipment') { badgeColor = "warning"; text = "Equipment Req."; }
           return <Badge color={badgeColor}>{text}</Badge>
        }
      },
      {
        Header: "Kategori",
        accessor: "Categories.Name", 
        Cell: (cellProps) => <span>{cellProps.row.original.Categories?.Name || "-"}</span>
      },
      {
        Header: "Bütçe/Fiyat",
        accessor: "BudgetRange",
        Cell: (cellProps) => {
            if(cellProps.value) return <span>{cellProps.value}</span>;
            return <span>{cellProps.row.original.PriceValue ? `${cellProps.row.original.PriceValue} ${cellProps.row.original.PriceCurrency}` : '-'}</span>
        }
      },
      {
        Header: "Durum",
        accessor: "Status",
        Cell: (cellProps) => {
            const statusMap = { 'active': 'success', 'pending': 'warning', 'rejected': 'danger' };
            return <Badge color={statusMap[cellProps.value] || 'light'}>{cellProps.value.toUpperCase()}</Badge>
        }
      },
      {
        Header: "İşlemler",
        Cell: (cellProps) => (
            <div className="d-flex gap-2 align-items-center">
              {/* ONAY BUTONU */}
              {cellProps.row.original.Status === 'pending' && (
                  <Button 
                    size="sm" 
                    color="success" 
                    onClick={() => handleApprove(cellProps.row.original)}
                    title="İlanı Onayla"
                  >
                    <i className="mdi mdi-check-bold"></i>
                  </Button>
              )}

              <button className="btn btn-sm btn-soft-info" onClick={() => handleEditClick(cellProps.row.original)}>
                <i className="mdi mdi-pencil" />
              </button>
              <button className="btn btn-sm btn-soft-danger" onClick={() => handleDeleteClick(cellProps.row.original)}>
                <i className="mdi mdi-delete" />
              </button>
            </div>
        ),
      },
    ], []
  );

  // --- Modal & Actions ---
  const toggleModal = () => {
    setModal(!modal);
    if (!modal && !isEdit) {
        validation.resetForm();
        setUploadedImage(null);
        setActiveTab("1");
    }
  };

  const handleEditClick = (data) => {
    setListingEdit(data);
    setIsEdit(true);
    if (data.ListingImages && data.ListingImages.length > 0) {
        const cover = data.ListingImages.find(x => x.IsCover) || data.ListingImages[0];
        setUploadedImage(cover.Url);
    } else {
        setUploadedImage(null);
    }
    setModal(true);
  };

  const handleAddClick = () => {
    setListingEdit(null);
    setIsEdit(false);
    setUploadedImage(null);
    setActiveTab("1");
    setModal(true);
  };

  const handleDeleteClick = (data) => {
    setListingToDelete(data);
    setDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (listingToDelete) {
        try {
            await axios.delete(`${API_URL}(${listingToDelete.ID})`);
            toastr.success("Silindi.");
            fetchListings();
        } catch (error) { toastr.error("Silme hatası."); }
    }
    setDeleteModal(false);
  };

  const toggleTab = (tab) => { if (activeTab !== tab) setActiveTab(tab); };

  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={confirmDelete} onCloseClick={() => setDeleteModal(false)} />
      
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="İlan & Talepler" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  
                  {/* --- FİLTRE ALANI --- */}
                  <div className="mb-3">
                    <Button color="primary" size="sm" onClick={() => setShowFilters(!showFilters)} className="mb-2">
                         <i className="mdi mdi-filter-outline me-1"></i> Filtrele / Sorgula
                    </Button>
                    <Collapse isOpen={showFilters}>
                        <div className="p-3 bg-light rounded border">
                            <Row>
                                <Col md={3} className="mb-2">
                                    <Label className="font-size-12">Kategori</Label>
                                    <Input type="select" bsSize="sm" value={filters.category} onChange={e => setFilters({...filters, category: e.target.value})}>
                                        <option value="">Tümü</option>
                                        {categoriesList.map(c => <option key={c.ID} value={c.ID}>{c.Name}</option>)}
                                    </Input>
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Label className="font-size-12">İlan Tipi</Label>
                                    <Input type="select" bsSize="sm" value={filters.type} onChange={e => setFilters({...filters, type: e.target.value})}>
                                        <option value="">Tümü</option>
                                        <option value="request_service">Service Request</option>
                                        <option value="request_equipment">Equipment Request</option>
                                    </Input>
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Label className="font-size-12">Aciliyet</Label>
                                    <Input type="select" bsSize="sm" value={filters.urgency} onChange={e => setFilters({...filters, urgency: e.target.value})}>
                                        <option value="">Tümü</option>
                                        {URGENCY_LEVELS.map(u => <option key={u} value={u}>{u}</option>)}
                                    </Input>
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Label className="font-size-12">Durum</Label>
                                    <Input type="select" bsSize="sm" value={filters.status} onChange={e => setFilters({...filters, status: e.target.value})}>
                                        <option value="">Tümü</option>
                                        <option value="pending">Onay Bekleyen (Pending)</option>
                                        <option value="active">Yayında (Active)</option>
                                        <option value="rejected">Reddedildi</option>
                                    </Input>
                                </Col>
                                <Col md={3}>
                                    <Label className="font-size-12">Doküman Durumu</Label>
                                    <Input type="select" bsSize="sm" value={filters.hasDocuments} onChange={e => setFilters({...filters, hasDocuments: e.target.value})}>
                                        <option value="">Hepsi</option>
                                        <option value="true">Var (Yes)</option>
                                        <option value="false">Yok (No)</option>
                                    </Input>
                                </Col>
                            </Row>
                        </div>
                    </Collapse>
                  </div>

                  <TableContainer
                    columns={columns}
                    data={filteredListings}
                    isGlobalFilter={true}
                    isAddSubCat1={true}
                    handleOrderClicks={handleAddClick}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* --- MODAL --- */}
          <Modal isOpen={modal} toggle={toggleModal} size="xl" scrollable={true}>
            <ModalHeader toggle={toggleModal} tag="h4">
              {isEdit ? "İlan Düzenle" : "Yeni Talep/İlan Oluştur"}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                
                {/* TİP SEÇİMİ VE ID BİLGİSİ */}
                <Row className="mb-3 bg-soft-light p-2 rounded">
                    <Col md={6}>
                        <Label>Talep Tipi (Type)</Label>
                        <Input type="select" name="Type" value={validation.values.Type} onChange={validation.handleChange} disabled={isEdit}>
                            <option value="request_service">Service Request (Hizmet Talebi)</option>
                            <option value="request_equipment">Equipment Request (Ekipman Talebi)</option>
                        </Input>
                    </Col>
                    <Col md={3}>
                        <Label>Listing ID</Label>
                        <Input type="text" value={isEdit ? listingEdit?.ID : "Otomatik"} disabled />
                    </Col>
                    <Col md={3}>
                        <Label>Listing Date</Label>
                        <Input type="text" value={isEdit ? moment(listingEdit?.CreatedAt).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY')} disabled />
                    </Col>
                </Row>

                <Nav tabs className="nav-tabs-custom mb-3">
                    <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")}>Genel Bilgiler</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")}>Detaylar & Özellikler</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3")}>Bütçe & Lokasyon</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "4" })} onClick={() => toggleTab("4")}>Medya & Doküman</NavLink></NavItem>
                </Nav>

                <TabContent activeTab={activeTab} className="p-3 border-bottom mb-3">
                    {/* TAB 1: GENEL */}
                    <TabPane tabId="1">
                        <Row>
                            <Col md={8} className="mb-3">
                                <Label>İlan Başlığı (Title) *</Label>
                                <Input name="Title" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.Title} invalid={!!(validation.touched.Title && validation.errors.Title)} />
                                <FormFeedback>{validation.errors.Title}</FormFeedback>
                            </Col>
                            <Col md={4} className="mb-3">
                                <Label>Kategori *</Label>
                                <Input type="select" name="CategoryID" value={validation.values.CategoryID} onChange={validation.handleChange} invalid={!!(validation.touched.CategoryID && validation.errors.CategoryID)}>
                                    <option value="">Seçiniz</option>
                                    {categoriesList.map(c => <option key={c.ID} value={c.ID}>{c.Name}</option>)}
                                </Input>
                                <FormFeedback>{validation.errors.CategoryID}</FormFeedback>
                            </Col>
                            {/* ModalBody içindeki Formun içinde uygun bir yere ekle (Örn: Kategori'nin yanına) */}

<Col md={4} className="mb-3">
    <Label>İlan Sahibi (Kullanıcı) *</Label>
    <Input
        type="select"
        name="UserID"
        value={validation.values.UserID}
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        invalid={!!(validation.touched.UserID && validation.errors.UserID)}
    >
        <option value="">Kullanıcı Seçiniz</option>
        {usersList.map((user) => (
            <option key={user.ID} value={user.ID}>
                {/* Kullanıcının Adı yoksa Emailini göster */}
                {user.FullName ? `${user.FullName} (ID: ${user.ID})` : `${user.Email} (ID: ${user.ID})`}
            </option>
        ))}
    </Input>
    <FormFeedback>{validation.errors.UserID}</FormFeedback>
</Col>

                            <Col md={4} className="mb-3">
                                <Label>Firma ID (Opsiyonel)</Label>
                                <Input type="number" name="CompanyID" value={validation.values.CompanyID} onChange={validation.handleChange} placeholder="Admin tarafından girilebilir" />
                            </Col>
                            <Col md={4} className="mb-3">
                                <Label>Yayın Durumu</Label>
                                <Input type="select" name="Status" value={validation.values.Status} onChange={validation.handleChange}>
                                    <option value="pending">Onay Bekliyor (Pending)</option>
                                    <option value="active">Yayında (Active)</option>
                                    <option value="rejected">Reddedildi</option>
                                </Input>
                            </Col>
                            <Col md={12} className="mb-3">
                                <Label>Açıklama (Description)</Label>
                                <Input type="textarea" rows="4" name="Description" onChange={validation.handleChange} value={validation.values.Description} />
                            </Col>
                        </Row>
                    </TabPane>

                    {/* TAB 2: DETAYLAR (DİNAMİK ALANLAR) */}
                    <TabPane tabId="2">
                        {validation.values.Type === 'request_service' && (
                            <Row>
                                <Col md={12} className="mb-3"><h6 className="text-primary">Service Request Kriterleri</h6></Col>
                                <Col md={6} className="mb-3">
                                    <Label>Service Type</Label>
                                    <Input type="select" name="ServiceType" value={validation.values.ServiceType} onChange={validation.handleChange}>
                                        <option value="">Seçiniz</option>
                                        {SERVICE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                                    </Input>
                                </Col>
                            </Row>
                        )}

                        {validation.values.Type === 'request_equipment' && (
                            <Row>
                                <Col md={12} className="mb-3"><h6 className="text-warning">Equipment Request Kriterleri</h6></Col>
                                <Col md={6} className="mb-3">
                                    <Label>Manufacturer (Üretici)</Label>
                                    <Input type="text" name="Manufacturer" value={validation.values.Manufacturer} onChange={validation.handleChange} />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Label>Equipment Type</Label>
                                    <Input type="select" name="EquipmentType" value={validation.values.EquipmentType} onChange={validation.handleChange}>
                                         <option value="">Seçiniz</option>
                                         {EQUIPMENT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                                    </Input>
                                </Col>
                                <Col md={4} className="mb-3">
                                    <Label>Satış Durumu (Sales Status)</Label>
                                    <Input type="select" name="SaleType" value={validation.values.SaleType} onChange={validation.handleChange}>
                                        <option value="sale">Satılık (Sale)</option>
                                        <option value="rent">Kiralık (Rental)</option>
                                    </Input>
                                </Col>
                                <Col md={4} className="mb-3">
                                    <Label>Ekipman Durumu</Label>
                                    <Input type="select" name="Condition" value={validation.values.Condition} onChange={validation.handleChange}>
                                        <option value="new">Sıfır (New)</option>
                                        <option value="used">İkinci El (Used)</option>
                                    </Input>
                                </Col>
                            </Row>
                        )}

                        <Row className="mt-3">
                            <Col md={12}><hr/></Col>
                            <Col md={6} className="mb-3">
                                <Label>Aciliyet (Urgency)</Label>
                                <Input type="select" name="Urgency" value={validation.values.Urgency} onChange={validation.handleChange}>
                                    {URGENCY_LEVELS.map(u => <option key={u} value={u}>{u}</option>)}
                                </Input>
                            </Col>
                            <Col md={6} className="mb-3">
                                <Label>Talep Edilen Teslim Tarihi</Label>
                                <Input type="date" name="RequiredDeliveryDate" value={validation.values.RequiredDeliveryDate} onChange={validation.handleChange} />
                            </Col>
                        </Row>
                    </TabPane>

                    {/* TAB 3: BÜTÇE & LOKASYON */}
                    <TabPane tabId="3">
                        <Row>
                            <Col md={6} className="mb-3">
                                <Label>Hedef Bütçe Aralığı (Budget Range)</Label>
                                <Input type="select" name="BudgetRange" value={validation.values.BudgetRange} onChange={validation.handleChange}>
                                    <option value="">Seçiniz</option>
                                    {BUDGET_RANGES.map(b => <option key={b} value={b}>{b}</option>)}
                                </Input>
                            </Col>
                            <Col md={6} className="mb-3">
                                <Label>Veya Kesin Fiyat</Label>
                                <Input type="number" name="PriceValue" value={validation.values.PriceValue} onChange={validation.handleChange} placeholder="0.00" />
                            </Col>
                            <Col md={6} className="mb-3">
                                <Label>Ülke (Location)</Label>
                                <Input type="text" name="LocationCountry" value={validation.values.LocationCountry} onChange={validation.handleChange} />
                            </Col>
                            <Col md={6} className="mb-3">
                                <Label>Şehir</Label>
                                <Input type="text" name="LocationCity" value={validation.values.LocationCity} onChange={validation.handleChange} />
                            </Col>
                             <Col md={6} className="mb-3">
                                <Label>İlanın Yayında Kalma Süresi (Bitiş)</Label>
                                <Input type="date" name="ListingExpirationDate" value={validation.values.ListingExpirationDate} onChange={validation.handleChange} />
                            </Col>
                        </Row>
                    </TabPane>

                    {/* TAB 4: MEDYA */}
                    <TabPane tabId="4">
                        <Row>
                            <Col md={12} className="mb-3">
                                <Label>Görsel / Video Yükle (Firebase)</Label>
                                <Input type="file" onChange={(e) => { if(e.target.files[0]) handleImageUpload(e.target.files[0]); }} />
                                {uploading && <div className="mt-2 text-primary"><Spinner size="sm"/> Yükleniyor...</div>}
                                {uploadedImage && <div className="mt-2"><img src={getImageUrl(uploadedImage)} alt="Preview" style={{height:'100px'}} className="img-thumbnail"/></div>}
                            </Col>
                            <Col md={12}>
                                <div className="form-check form-switch mb-2">
                                    <Input type="checkbox" className="form-check-input" id="HasDocuments" name="HasDocuments" checked={validation.values.HasDocuments} onChange={validation.handleChange} />
                                    <Label className="form-check-label" htmlFor="HasDocuments">İlişkili Doküman Var (Yes/No)</Label>
                                </div>
                                 <div className="form-check form-switch mb-2">
                                    <Input type="checkbox" className="form-check-input" id="ContactHidden" name="ContactHidden" checked={validation.values.ContactHidden} onChange={validation.handleChange} />
                                    <Label className="form-check-label" htmlFor="ContactHidden">İletişim Bilgileri Gizli</Label>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>

                <div className="text-end">
                    <button type="button" className="btn btn-secondary me-2" onClick={toggleModal}>İptal</button>
                    <button type="submit" className="btn btn-success" disabled={uploading}>{isEdit ? "Güncelle" : "Kaydet"}</button>
                </div>
              </Form>
            </ModalBody>
          </Modal>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ListingsList);